import { toast } from '@design-system/components/atoms'
import type React from 'react'
import { TOAST_STR } from 'src/constant'
import type { CommonError } from 'src/dto'

type ToastMessage = string | (() => string)

const resolveMessage = (msg: ToastMessage): string => (typeof msg === 'function' ? msg() : msg)

export const toastSuccess = (text: ToastMessage, actionButton?: React.ReactNode) => {
  return toast.success(resolveMessage(text), actionButton)
}

export const toastNotice = (text: ToastMessage) => {
  return toast.info(resolveMessage(text))
}

export const toastError = (text: ToastMessage, actionButton?: React.ReactNode) => {
  return toast.error(resolveMessage(text), actionButton)
}

export const toastFailure = (text: ToastMessage, actionButton?: React.ReactNode) => {
  return toast.failure(resolveMessage(text), actionButton)
}

export const toastDelete = (text: ToastMessage) => {
  return toast.delete(resolveMessage(text))
}

// Error Code가 400번대이면 백엔드 메세지, 500번대이면 TOAST_STR.errorMessage, 400이면 toastError 띄우지 않고, response 리턴해서 화면에서 처리한다.
export const commonErrorMessage = (error: CommonError) => {
  if (error.type === 'CORS') {
    toastError(error.message)
  }

  if (error.message === 'canceled') return
  console.error(error)

  if (error.type === 'API') {
    const code = Number(error.status)
    if (code > 400 && code < 500) {
      toastError(error.message)
    } else if (code >= 500) {
      toastError(TOAST_STR.errorMessage)
    }
  }

  if (error.type === 'client' && !error.disableToast) {
    toastError(error.message ?? TOAST_STR.errorMessage)
  }

  return error
}
